import * as React from 'react';
import * as ReactGA from 'react-ga';
import { ReactNode } from 'react';
import { RootState } from 'src/reducers/RootReducer';
import { connect } from 'react-redux';
import { googleAnalyticsTrackingId } from 'src/resources/const';

interface StateProps {
  location: string | null;
}

interface Props extends StateProps {
}

class GAListener extends React.Component<Props, {}> {

  public shouldComponentUpdate(nextProps: Props): boolean {
    if (this.props.location === nextProps.location) {
      return true;
    }

    this.sendPageView(nextProps.location!);
    return true;
  }

  public componentDidMount(): void {
    ReactGA.initialize(googleAnalyticsTrackingId);
    this.sendPageView(this.props.location!);
  }

  public render(): ReactNode {
    return (
      React.Children.only(this.props.children)
    );
  }

  private sendPageView(location: string) {
    ReactGA.set({ page: location });
    ReactGA.pageview(location);
  }
}

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  location: state.router.location ? state.router.location.pathname : '',
});

export default connect(mapStateToProps)(GAListener);



// WEBPACK FOOTER //
// ./src/services/middleware/GAListener.tsx